import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.array.find";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import LambdaApiService from '../../../../services/apiService/lambda';
import { mapState } from 'vuex';
import cloneDeep from 'lodash/cloneDeep';
export default {
  name: 'CoreDtwinRuleEditMetrics',
  props: {
    rule: {
      type: Object,
      required: true
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false
    },
    // the states that are to be displayed / edited
    states: {
      type: Array,
      required: true
    },
    templateContext: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data: function data() {
    var _this = this;

    return {
      operations: [{
        value: 'sum',
        text: 'SUM()'
      }, {
        value: 'count',
        text: 'COUNT()'
      }, {
        value: 'min',
        text: 'MIN()'
      }, {
        value: 'max',
        text: 'MAX()'
      }, {
        value: 'avg',
        text: 'AVG()'
      }, {
        value: 'last',
        text: 'LAST()'
      }, {
        value: 'since_last_update',
        text: 'SINCE_LAST_UPDATE()'
      }],
      operators: [{
        value: 'and',
        text: 'AND'
      }, {
        value: 'or',
        text: 'OR'
      }],
      transformerErrors: {},
      stateMetricKeyUnique: [function (v) {
        return !!v && /^[A-Za-z]{1}[A-Za-z0-9_]*$/g.exec(v) !== null || _this.$i18n_t('DigitalTwin.DigitalTwin.ruleModeler.stateMetricKeyAlert');
      }, function (v) {
        return !!v && _this.rule.properties.stateMetrics.filter(function (s) {
          return s.key === v;
        }).length <= 1 || 'Must have a unique name';
      }],
      stateMetricTransformerValid: [function (v) {
        return !!v && _this.transformerErrors[v] === undefined || _this.transformerErrors[v] || 'Must specify a valid transformer';
      }],
      requiredRule: [function (v) {
        return !!v || _this.$i18n_t('Common.fieldRequired');
      }]
    };
  },
  computed: _objectSpread({}, mapState('app', ['inpOutlined', 'inpFilled', 'image', 'color', 'UiTheme'])),
  methods: {
    evaluateTransformer: function evaluateTransformer(stateMetric) {
      var _this2 = this;

      var transform = stateMetric.transform;
      var script = "module.exports = (x) => {\n        return ".concat(transform, ";\n      }");
      return LambdaApiService.evaluateScript({
        script: script,
        scriptParams: [42]
      }).then(function (result) {
        // TODO: clean up unused/outdated transformer errors(?)
        if (result.syntaxError) {
          _this2.transformerErrors[transform] = result.syntaxError;
          _this2.transformerErrors = cloneDeep(_this2.transformerErrors);

          _this2.validateForm();
        }
      });
    },
    stateIsNumeric: function stateIsNumeric(stateMetric) {
      var searchField = this.templateContext ? 'key' : 'id';
      var state = this.states.find(function (s) {
        return s[searchField] === stateMetric.stateId;
      });

      if (state) {
        return state.properties.valueType === 'number';
      }

      return true;
    },
    stateTitle: function stateTitle(stateMetric) {
      var searchField = this.templateContext ? 'key' : 'id';
      var state = this.states.find(function (s) {
        return s[searchField] === stateMetric.stateId;
      });

      if (state) {
        return state.properties.title;
      }

      return undefined;
    },
    editRuleOperationsForMetric: function editRuleOperationsForMetric(stateMetric) {
      var numericState = this.stateIsNumeric(stateMetric);

      if (!numericState) {
        return this.operations.filter(function (op) {
          return op.value === 'last' || op.value === 'since_last_update';
        });
      }

      return this.operations;
    },
    openDigitalTwinOfState: function openDigitalTwinOfState(bindingId) {
      window.open("#".concat(this.$router.currentRoute.path, "?stateId=").concat(bindingId), '_blank');
    }
  }
};